import React from 'react';

const statusStyles = {
	DROPOUT: { backgroundColor: 'red', color: 'white' },
	OFFERED: { backgroundColor: 'orange', color: 'white' },
	TRAINING: { backgroundColor: 'purple', color: 'white' },
	DROP: { backgroundColor: 'gray', color: 'white' },
	HIRED: { backgroundColor: 'green', color: 'white' },
};

const StatusButtons = ({ item }) => {
	const status = item?.applicationStatus;
	const style = statusStyles[status] || {};

	return (
		<div>
			{status && (
				<button
					style={{
						...style,
						padding: '4px 10px',
						margin: '5px',
						border: 'none',
						borderRadius: '5px',
						fontWeight: 'bold',
					}}
				>
					{status.charAt(0) + status.slice(1).toLowerCase()}
				</button>
			)}
		</div>
	);
};

export default StatusButtons;
